export class ClaimsFnolFormControls {
  /**
   * report-claim-incident-time-component form controls.
   */
  public static readonly DATE_OF_INCIDENT = 'dateOfIncident';
  public static readonly TIME_OF_INCIDENT = 'timeOfIncident';
  public static readonly AM_PM_SELECTION = 'amPmSelection';

  /**
   * report-claim-incident-location-component form controls.
   */
  public static readonly INCIDENT_CITY = 'incidentCity';
  public static readonly INCIDENT_STATE = 'incidentState';
  public static readonly LOSS_LOCATION_TYPE = 'lossLocationType';
  public static readonly LOSS_INJURIES = 'lossInjuries';

  /**
   * report-claim-loss-cause-component form controls.
   */
  public static readonly LOSS_CAUSE = 'lossCause';
  public static readonly COLLISION_STATIONARY = 'collisionStationary';
  public static readonly COLLISION_LOSS = 'collisionLoss';
  public static readonly WEATHER_LOSS = 'weatherLoss';
  public static readonly THEFT_VANDALISM = 'theftLoss';

  /**
   * report-claim-contact-info-component form controls
   */

  public static readonly WHAT_HAPPENED = 'whatHappened';
  public static readonly EMAIL_ADDRESS = 'emailAddress';
  public static readonly PHONE_NUMBER = 'phoneNumber';
}
